<template>
    <svg  width="1em" height="1em" 
            viewBox="0 0 1024 1024" class="icon"  
            version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M834.133333 149.333333h-78.933333C473.6 153.6 151.466667 514.133333 149.333333 755.2v78.933333c0 21.333333 17.066667 40.533333 40.533334 40.533334l160-2.133334c21.333333 0 40.533333-19.2 40.533333-40.533333l4.266667-174.933333-100.266667-85.333334c0-55.466667 224-279.466667 281.6-281.6l91.733333 100.266667 168.533334-4.266667c21.333333 0 40.533333-19.2 40.533333-40.533333L874.666667 189.866667c0-23.466667-17.066667-40.533333-40.533334-40.533334z" fill="#009688" />
    </svg>
</template>
<script>
export default {
    name : 'PhoneSVG'
}
</script>